import React,{useState} from 'react';
import { connect } from 'react-redux';
import ImageViewUpload from '../../common/product-image/ImageViewUpload';
import { useHistory } from 'react-router-dom';
import { setRedirectedFrom, updateProductMedia, deleteVendorImages,setSelectedType } from '../../actions/products';
import { updateItemImage, resetItemInfo } from '../../actions/items';
import Button from 'jd-library/Button'
import { getImagePath } from '../../common/productImageUtils';
import historyHandler from 'jd-library/historyHandler';
import toastMessageActions from "jd-library/toastMessageActions";
import PhotoGallerySliders from './PhotoGallerySliders';
import PhotoSlider from './PhotoSlider';
import {
    setSelectedGalleryImages,
    toggleGalleryModal,
    togglePhotoSlider
} from '../../actions/photosGallery';
import {checkLoggedIn} from "../../utills";
import {getProductData} from '../../actions/products'

const HorizontalPhotoList = (props) => {
    const history = useHistory();
    const selectedImages = props.selectedImages;

    if(!props.vendorImages?.length) {
        return null
    }

    const AddProduct = (productData = {},selectedProductType='product') => {
        props.setSelectedType({
            selectedCategoryType: selectedProductType
        })
        if(props.isMobile){
            if(productData.generic_p_id) {
                history.push(`/products/${props.session.viaOmni ? 'edit-omni' : 'edit'}/${productData.generic_p_id}?isGenericProduct=true&selectedProductType=`+selectedProductType);
            } else {
                history.push(`/products/${props.session.viaOmni ? 'add-omni' : 'add'}?selectedProductType=${selectedProductType}&fromPhotos=true`);
            }
        }else{
            const options = {
                productId : 'ADD_PRODUCT'
            };
            if (productData.generic_p_id){
                options.productId = productData.generic_p_id;
                options.isTemplateProduct = true;
            }      
            props.getProductData(options);
        }
    }

    const addDescription = (image, productData,bifurcateType) => {
        historyHandler.closeCurrent();
        setTimeout(()=>{
            if(props.session.source == 'webstore'){
                props.resetItemInfo();
                props.setRedirectedFrom({redirectedFrom: 'photos'});
                history.push('/add-item');
                props.updateItemImage(image);
            }else{
                if (props.session.showCompanyDetails) {
                    checkLoggedIn({
                        cb: () => AddProduct(productData,bifurcateType),
                        history
                    });
                } else {
                    AddProduct(productData,bifurcateType);
                }
                if(!image.base64Url){
                    image.finalImageSrc = image.finalImageSrc ? image.finalImageSrc : getImagePath(image.imageUrl)
                    image.imgURL = image.imgURL ? image.imgURL : image.imageUrl
                }
                props.updateProductMedia({
                    imageUrl: image,
                    editProductId: "ADD_PRODUCT",
                    source: "b2b",
                    isAddEditProduct: true
                })
            }
        }, 400)
    }

    return(
        <>
            <div className="horizontal-photo-list">
                <div className="heading-with-button">
                    Photos
                    <Button
                        className="view-all-button"
                        size='md'
                        children='View All'
                        variant='text'
                        onClick={()=>{
                            props.setSelectedGalleryImages([]);
                            if(props.isMobile){
                                history.push('/products/photos');
                            }else{
                                props.togglePhotoSlider({
                                    selectPhotoSlider: true,
                                    // isJdPhotoSlider: true,
                                })
                            }
                        }}
                    />
                </div>
                <div className="photo-slider">
                    {
                        props.vendorImages.map((cur, index)=>{
                            return(
                                <ImageViewUpload 
                                    imageUrlArr={[cur]}
                                    customCB = {()=>{
                                        props.setSelectedGalleryImages([index])
                                        props.toggleGalleryModal({
                                            addModal: {
                                                show: true
                                            }
                                        })
                                    }}
                                />
                            )
                        })
                    }
                    <div className="padding-right-elem"></div>
                </div>
            </div>
            {!props.selectPhotoSlider ? <PhotoGallerySliders 
                combinePhotos={(productData,bifurcateType)=>{
                    addDescription(...props.vendorImages.filter((cur, index)=> selectedImages.includes(index)), productData,bifurcateType);
                   
                }}
                deletePhotos={() => {
                    const imagesToDelete = [];
                    props.vendorImages.filter((cur, index) => {
                        const isDeleted = selectedImages.includes(index);
                        if(isDeleted){
                            imagesToDelete.push(cur.galleryId);
                        }
                        return !isDeleted
                    })
                    props.deleteVendorImages({
                        imagesToDelete,
                        supplierId: props.session.supplierId
                    })
                }}  
            /> : null}
        </>
    )
}

const mapStateToProps = (state, props) => {
    return{
        ...props,
        selectedImages: state.photosGallery.selectedImages,
        vendorImages: state.products.vendorImages,
        session: state.session,
        selectPhotoSlider: state.photosGallery.selectPhotoSlider,
        isMobile: state.deviceData.isMobile
    }
}
export default connect(mapStateToProps, {
    setRedirectedFrom,
    updateItemImage,
    updateProductMedia,
    deleteVendorImages,
    showToastMessage: toastMessageActions.showMessage,
    setSelectedGalleryImages,
    toggleGalleryModal,
    resetItemInfo,
    getProductData,
    togglePhotoSlider,
    setSelectedType
})(HorizontalPhotoList)